import { Button } from "antd";
import React, { useCallback } from "react";
import { AgentDetailSaveScope } from "../../../../../../../../agentDetail.model";
import { useAgentsStore } from "../../../../../../../../store/agents.store";
import { useAgentDetailSave } from "../../../../../../hooks/useAgentDetailSave";
import styles from "./footer.module.css";

interface FooterProps {
    saveScope?: AgentDetailSaveScope;
}

export const Footer = ({ saveScope = "all" }: FooterProps) => {
    const { save, isSaving, isDirty, canSave } = useAgentDetailSave(saveScope);
    const resetDraftScope = useAgentsStore((state) => state.resetDraftScope);

    const handleSave = useCallback(() => {
        void save();
    }, [save]);

    const handleCancel = useCallback(() => {
        resetDraftScope(saveScope);
    }, [resetDraftScope, saveScope]);

    return (
        <div className={styles.footer}>
            {isDirty && (
                <Button onClick={handleCancel} disabled={isSaving}>
                    Cancel
                </Button>
            )}
            <Button color="primary" variant="solid" onClick={handleSave} disabled={!canSave} loading={isSaving}>
                Save
            </Button>
        </div>
    );
};
